import "./App.css";
import React, { Component, Fragment, Fragmnet } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Orders from "./Orders/Orders";
import Order from "./Orders/Order/Order";
import Tickets from "./Tickets/Tickets";
import Ticket from "./Tickets/Ticket/Ticket";
import Comments from "./Comments/Comments";
import Items from "./Items/Items";
import Item from "./Items/Item/Item";
import Categories from "./Categories/Categories";
import Stories from "./Stories/Stories";
import Tiles from "./Tiles/page";
import Statistics from "./Statistics/Statistics";
import Coupons from "./Coupons/Coupons";
import Coupon from "./Coupons/Coupon/Coupon";
import Settings from "./Settings/Settings";
import withRouter from "./withRouter/withRouter";
import Toast from "./Toast/Toast";

import logo from "../logo.png";

const Connection = new (require("../classes/Connection").default)();

class App extends Component {
    constructor(props) {
        super(props);
        this.validateToken = this.validateToken.bind(this);
    }
    state = { currentPage: null, ready: false, navigate: null };
    componentDidMount(props) {
        this.validateToken();
        this.setState({
            currentPage: this.props.router.location.pathname.split("/")[1],
        });
    }

    goTo(e) {
        let destination = `/${e.target.getAttribute("destination")}/`;
        this.props.router.navigate(destination);
        this.setState({
            currentPage: destination.split("/")[1],
        });
    }

    exit() {
        localStorage.removeItem("un");
        localStorage.removeItem("admin_token");

        Connection.log_out().catch(console.log);
        this.props.router.navigate("/register");
    }

    validateToken() {
        let cookieUN = localStorage.getItem("un");
        let cookieToken = localStorage.getItem("admin_token");

        if (cookieUN && cookieToken) {
            //validate token
            Connection.validateToken(cookieUN, cookieToken)
                .then((res) => {
                    localStorage.setItem("un", cookieUN);
                    localStorage.setItem("admin_token", cookieToken);

                    this.setState({
                        ready: true,
                        un: res.data.un,
                        token: res.data.token,
                    });
                    //this.setState({ navigate: <Navigate to={"/orders"} /> });
                })
                .catch((err) => {
                    localStorage.removeItem("un");
                    localStorage.removeItem("admin_token");
                    this.toast(
                        "اعتبارسنجی",
                        "مدت اعتبار کلید شما منقضی شده است.\nلطفا مجددا وارد شوید",
                        " warning"
                    );
                    clearInterval(this.vaildateInterval);
                    this.setState({ ready: false });
                    this.setState({ navigate: <Navigate to={"/register"} /> });
                });
        } else {
            this.setState({ navigate: <Navigate to={"/register"} /> });
            this.setState({ ready: false });
        }
    }

    toast = (header, message, color, expire = 5000) => {};

    render() {
        let { currentPage, navigate, ready } = this.state;
        return (
            <div id='window'>
                <Toast
                    setToastHook={(cb) => {
                        this.toast = cb;
                    }}
                ></Toast>
                {navigate}
                <div className='menuFloatingIcon'>
                    <input type='checkbox' name='menucb' />
                    <i className='ri-menu-2-line'></i>
                </div>
                <div className='menu'>
                    <div className='logo'>
                        <img src={logo} />
                    </div>
                    <div
                        className={
                            "name " +
                            (currentPage == "orders" ? "selected" : "")
                        }
                        destination='orders'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-solid fa-file-invoice-dollar'></i>
                        سفارشات
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "tickets" ? "selected" : "")
                        }
                        destination='tickets'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-solid fa-headset'></i>
                        درخواست های پشتیبانی
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "comments" ? "selected" : "")
                        }
                        destination='comments'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-regular fa-comments'></i>
                        نظرات
                    </div>

                    <div
                        className={
                            "name " + (currentPage == "items" ? "selected" : "")
                        }
                        destination='items'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-solid fa-cubes'></i>
                        کالاها
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "categories" ? "selected" : "")
                        }
                        destination='categories'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-solid fa-sitemap'></i>
                        دسته بندی ها
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "stories" ? "selected" : "")
                        }
                        destination='stories'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='ri-video-line'></i>
                        استوری صفحه اصلی
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "tiles" ? "selected" : "")
                        }
                        destination='tiles'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='ri-video-line'></i>
                        موزایک های صفحه اصلی
                        <div className='new-badge'>جدید</div>
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "coupons" ? "selected" : "")
                        }
                        destination='coupons'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='ri-coupon-3-fill'></i>
                        کد های تخفیف
                    </div>

                    {/* <div
                        className={
                            "name " +
                            (currentPage == "costumers" ? "selected" : "")
                        }
                        destination="costumers"
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        مشتریان
                    </div> */}

                    <div
                        className={
                            "name " +
                            (currentPage == "statistics" ? "selected" : "")
                        }
                        destination='statistics'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-solid fa-chart-column'></i>
                        آمار
                    </div>

                    <div
                        className={
                            "name " +
                            (currentPage == "settings" ? "selected" : "")
                        }
                        destination='settings'
                        onClick={(e) => {
                            this.goTo(e);
                        }}
                    >
                        <i className='fa-solid fa-gears'></i>
                        تنظیمات سایت
                    </div>
                    <div
                        className='name '
                        onClick={(e) => {
                            this.exit();
                        }}
                    >
                        <i className='fa-solid fa-arrow-up-right-from-square'></i>
                        خروج
                    </div>
                </div>
                {ready && (
                    <div className='workArea'>
                        <Routes>
                            <Route
                                path='orders'
                                element={
                                    <Orders
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/orders/:id'
                                element={
                                    <Order
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/tickets'
                                element={
                                    <Tickets
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/tickets/:id'
                                element={
                                    <Ticket
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/comments'
                                element={
                                    <Comments
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/items'
                                element={
                                    <Items
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/items/:id'
                                element={
                                    <Item
                                        mode='edit'
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/items/new'
                                element={
                                    <Item
                                        mode='new'
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/categories'
                                element={
                                    <Categories
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/categories/:id'
                                element={<Ticket />}
                            ></Route>
                            <Route
                                path='/stories'
                                element={
                                    <Stories
                                        toast={this.toast}
                                        connection={Connection}
                                        
                                    />
                                }
                            ></Route>
                             <Route
                                path='/tiles'
                                element={
                                    <Tiles
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            {/* <Route
                                path="/costumers"
                                element={
                                    <Ticket
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route> */}
                            <Route
                                path='/costumers/:id'
                                element={
                                    <Ticket
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>

                            <Route
                                path='/coupons/'
                                element={
                                    <Coupons
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/coupon/new'
                                element={
                                    <Coupon
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/coupon/code/:code'
                                element={
                                    <Coupon
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/statistics'
                                element={
                                    <Statistics
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/settings'
                                element={
                                    <Settings
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>
                            <Route
                                path='/*'
                                element={
                                    <Orders
                                        toast={this.toast}
                                        connection={Connection}
                                    />
                                }
                            ></Route>

                            {/* <Route
                                path="/"
                                element={<Navigate to="/site-settings" />}
                            ></Route> */}
                        </Routes>
                    </div>
                )}
            </div>
        );
    }
}

export default withRouter(App);
